import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Helpers } from '../helpers';
import { ScriptLoaderService } from '../_services/script-loader.service';
import { appService } from '../_services/app.service';
import { CommonService } from '../_services/common.service';
import { environment } from '../../environments/environment';
import { CommonModule, DatePipe } from "@angular/common";

declare var $: any;
@Component({
  selector: 'app-bid-transporter',
  templateUrl: './bid-transporter.component.html',
  styleUrls: ['./bid-transporter.component.scss']
})
export class BidTransporterComponent implements OnInit {
  ShowAvailabilityDate: boolean = true;
  totalBidAmount: number = 0;
  selectedVehicles: { VehicleReqiredId: any, AvailableDate: any, VehicleAmount: any }[] = [];
  OrderData: any = {};
  IndentId: string = '';
  SumOfQty: any = 0;
  SumOfWeight: any = 0;
  TransporterList: any[] = [];
  TransporterId: any = '';
  BidTransporter: any = {};
  isBidOpen: boolean = true;
  whitelabelFlag: boolean = false;
  //added by vithujan 19-06-2023
  hostUrl: any = environment.apiUrl;
  VehicleDetails: any[]
  AvailableDate: any;
  VehicleReqiredId: any;
  constructor(
    private _appService: appService,
    private toastr: ToastrService,
    private _activatedRoute: ActivatedRoute,
    private commonService: CommonService,
    private CommonModule: CommonModule,
    private _script: ScriptLoaderService
  ) { }

  ngOnInit() {
    this._script
      .loadScripts(
        "body",
        [
          "assets/vendors/base/vendors.bundle.js",
          "assets/demo/default/base/scripts.bundle.js"
        ],
        true
      )
      .then(() => {
        this._activatedRoute.params.subscribe((params: Params) => {
          this.IndentId = this._activatedRoute.snapshot.queryParams["IndentId"];
          this.TransporterId = this._activatedRoute.snapshot.queryParams["Transporter"];
          this.whitelabelFlag = JSON.parse(localStorage.getItem("whitelabelFlag"));

          if (this.IndentId == undefined || this.IndentId == null) {
            this.IndentId = this._activatedRoute.snapshot.queryParams["indentid"];
            this.TransporterId = this._activatedRoute.snapshot.queryParams["transporter"];
            this.whitelabelFlag = JSON.parse(localStorage.getItem("whitelabelflag"));
          }
          if (this.IndentId !== undefined && this.IndentId !== null) {
            this.GetRequiredData();
          }
        });
        this.RefreshvalidDate();
        this.calculateTotalBidAmount();
      });
  }

  GetRequiredData() {
    this._appService.GetByTwoId("OrdersByVehicle", "GetOrderVehicleById", this.IndentId, null).subscribe(
      (response) => {
        this.OrderData = response;
        console.log(this.OrderData.VehicleList, 'OrderData.VehicleList')
        this.CalcSum();

        this.GetTransporterListHired();

        if (this.OrderData.BidOpen == false || this.OrderData.BidOpen == null) {
          this.isBidOpen = true;
        } else {
          this.isBidOpen = false;
        }
        console.log(this.OrderData);
      },
      (err) => {
        this.toastr.error(
          "An erro occured while Update Data",
          "ChargeType"
        );
      }
    );
  }

  CalcSum() {
    for (let i = 0; i < this.OrderData.ProductList.length; i++) {
      this.SumOfQty += (this.OrderData.ProductList[i].Qty ? this.OrderData.ProductList[i].Qty : 0);
      this.SumOfWeight += (this.OrderData.ProductList[i].weight ? this.OrderData.ProductList[i].weight : 0);
    }
  }

  GetTransporterListHired() {
    this._appService
      .Get("OrdersByVehicle", "GetTranspoterListHired")
      .subscribe(
        (response) => {

          var res = response;
          var transporter = res.find(c => c.Id == this.TransporterId);
          this.TransporterList.push(
            transporter
          );

          console.log(this.TransporterList);
        },
        (err) => {
          this.toastr.error(
            "Error occurred while fetching Status data !",
            "error"
          );
        }
      );
  }

  UpdateTransporterBids() {

    if (this.selectedVehicles.length == 0) {
      this.toastr.info('Please Select Atleast One VehcileType', 'info')
      return
    }
    if (
      !this.commonService.ValidateRequiredField(
        $("#Amount"),
        "Please Enter Bid Amount",
        "after",
        ""
      )
    ) {
      return;
    }
    if (
      !this.commonService.ValidateRequiredField(
        $("#transporter"),
        "Please select",
        "after",
        ""
      )
    ) {
      return;
    }
    if (
      !this.commonService.ValidateRequiredField(
        $("#AvailableDate"),
        "Please select Date",
        "after",
        ""
      )
    ) {
      return;
    }
    this.BidTransporter.Amount = this.totalBidAmount;
    this.VehicleDetails = this.selectedVehicles;
    this.BidTransporter.IndentId = this.IndentId;
    this.BidTransporter.TransporterId = this.TransporterId;
    this.BidTransporter.Vehicleslist = this.VehicleDetails
    console.log(this.BidTransporter, 'selectedVehicles for bidding ')
    this._appService
      .Post("OrdersByVehicle", "UpdateTransporterBid", this.BidTransporter)
      .subscribe(
        (response) => {
          Helpers.setLoading(false);

          if (response[0].isDone) {
            this.toastr.success("Bid Sent sucessfully !", "Success");
          } else {
            this.toastr.error("Your Bid Submission Failed !", "Error");
          }

        },
        (err) => {
          console.log(err);
          Helpers.setLoading(false);
          this.toastr.error(err._body.replace(/"/g, ""), "Error");
        }
      );
  }
  RefreshvalidDate() {
    setTimeout(() => {
      $(".datepickerforSalesRegister").datepicker({
        todayHighlight: !0,
        orientation: "auto",
        autoclose: true,
        format: "dd/mm/yyyy",
        setDate: new Date(),
        templates: {
          leftArrow: '<i class="la la-angle-left"></i>',
          rightArrow: '<i class="la la-angle-right"></i>',
        },
      });
    }, 200);
  }

  onDateChange(event: any, VehicleReqiredId: any) {
    const AvailableDate = event.target.value;
    const vehicle = this.selectedVehicles.find(vehicle => vehicle.VehicleReqiredId === VehicleReqiredId);
    if (vehicle) {
      vehicle.AvailableDate = AvailableDate;
    } else {
      const selectedVehicle = this.OrderData.VehicleList.find(v => v.Id === VehicleReqiredId);
      if (selectedVehicle) {
        this.selectedVehicles.push({
          VehicleReqiredId,
          AvailableDate,
          VehicleAmount: selectedVehicle.VehicleAmount || ''
        });
      }
    }
    this.calculateTotalBidAmount();
  }

  onCheckboxChange(event: any, vehicle: any) {
    const VehicleReqiredId = vehicle.Id;
    if (event.target.checked) {
      this.selectedVehicles.push({
        VehicleReqiredId,
        AvailableDate: '',
        VehicleAmount: vehicle.VehicleAmount || ''
      });
      this.ShowAvailabilityDate = false;
    } else {
      this.selectedVehicles = this.selectedVehicles.filter(v => v.VehicleReqiredId !== VehicleReqiredId);
      this.ShowAvailabilityDate = true;
    }
    this.calculateTotalBidAmount();
  }

  onAmountChange(vehicle: any) {
    const existingVehicle = this.selectedVehicles.find(v => v.VehicleReqiredId === vehicle.Id);
    if (existingVehicle) {
      existingVehicle.VehicleAmount = vehicle.VehicleAmount;
    }
    this.calculateTotalBidAmount();
  }

  calculateTotalBidAmount(): void {
    this.totalBidAmount = this.selectedVehicles.reduce((sum: number, vehicle: any) => {
      return sum + (parseFloat(vehicle.VehicleAmount) || 0);
    }, 0);
  }

}
